@if (model()) {
  <app-address-form [resource]="model()!"
                    [type]="'meeting_point'"
                    (formGroupOutput)="formGroup = $event"
                    [showNameField]="false"
                    [showActiveStatus]="true"/>
  @if (formGroup) {
    <div class="d-flex justify-content-end align-items-center mt-4">
      <app-mdb-button (onClick)="submit()" [text]="'SAVE'" [loading]="loading" />
    </div>
  }
}

@if (!model()) {
  <app-spinner />
}
